import prodClient from 'client/prod';
import messages from 'messages/ar.ton.json';

prodClient(messages);
